import { isEnergyCardInvoiceId } from '../../hookServices/energyCard';

/** Matches feedback/app/paid_session.py. */
const PAID_STATES = new Set(['DONE', 'PARTIALLY_REFUNDED', 'OVERCHARGED', 'IN_PROGRESS', 'TOP_UP_BALANCE']);

export function isPaidHistoryItem(item, stationNumbers) {
  if (!item || !PAID_STATES.has(item.state)) return false;
  const port = String(item.plugNumber ?? item.stationNumber ?? '').trim();
  const allowed = new Set((stationNumbers || []).map(value => String(value).trim()).filter(Boolean));
  if (!allowed.has(port)) return false;
  const price = Number(item.priceInCents) || 0;
  if (price > 0) return true;
  return isEnergyCardInvoiceId(item.invoiceId);
}

/** Port numbers among stationNumbers that have a successful payment. */
export function paidPortsInHistory(history, stationNumbers) {
  const found = [];
  const seen = new Set();
  for (const item of Array.isArray(history) ? history : []) {
    if (!isPaidHistoryItem(item, stationNumbers)) continue;
    const port = String(item.plugNumber ?? item.stationNumber ?? '').trim();
    if (!port || seen.has(port)) continue;
    seen.add(port);
    found.push(port);
  }
  return found;
}
